import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import { resources as IncomingRegularStudents } from "./IncomingRegularStudents";
import { resources as IncomingIntershipStudents } from "./IncomingIntershipStudents";
import { resources as Campaigns } from "./Campaigns";
import { resources as OutgoingApplications } from "./OutgoingApplications";
import { resources as IncomingTeachers } from "./IncomingTeachers";
import { resources as OutgoingTeachers } from "./OutgoingTeachers";
import { resources as Coordinators } from "./Coordinators";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <LocalLibraryIcon />,
  name: "Еразъм",
  title: "Еразъм",
  subMenu: [
    OutgoingApplications,
    IncomingRegularStudents,
    IncomingIntershipStudents,
    IncomingTeachers,
    OutgoingTeachers,
    Campaigns,
    Coordinators,
  ],
};
